<template>
    <div>
        <div class="x-stat">
            <a-row>
                <a-col :span="3">
                    <a-statistic title="数量" :value="totalRow" />
                </a-col>
            </a-row>
        </div>

        <a-card :bordered="false">
            <div class="x-filter">
                <a-form layout="inline">
                    <a-row :gutter="24">
                        <a-col :span="4">
                            <a-form-item label="用户">
                                <a-input v-model="queryParams.user" placeholder="ID/昵称" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="4">
                            <a-form-item label="类型">
                                <a-select v-model="queryParams.bizType" placeholder="请选择" default-value="">
                                    <a-select-option value="USER_PROFILE">用户资料</a-select-option>
                                    <a-select-option value="VOICE_MOTTO">声音秀</a-select-option>
                                    <a-select-option value="ALBUM">相册</a-select-option>
                                    <a-select-option value="MOMENT">动态</a-select-option>
                                    <a-select-option value="MOMENT_COMMENT">评论</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="4">
                            <a-form-item label="状态">
                                <a-select v-model="queryParams.status" placeholder="请选择" default-value="">
                                    <a-select-option value="PENDING">待审核</a-select-option>
                                    <a-select-option value="PASSED">通过</a-select-option>
                                    <a-select-option value="REJECTED">拒绝</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <template v-if="advanced">
                            <a-col :md="8">
                                <a-form-item label="创建时间">
                                    <a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
                                </a-form-item>
                            </a-col>
                        </template>
                        <a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
                                  :style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="getTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="() => this.queryParams={}">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>

            <div class="x-tool">
                <a-dropdown >
                    <a-menu slot="overlay" @click="batchAudit">
                        <a-menu-item key="Y">通过</a-menu-item>
                        <a-menu-item key="N">拒绝</a-menu-item>
                    </a-menu>
                    <a-button>批量审核<a-icon type="down" /> </a-button>
                </a-dropdown>
            </div>

            <a-table :rowKey="record => record.id" :columns="tableColumns" :loading="tableLoading"
                     :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                     :dataSource="tableData" :pagination="false">
                <template slot="user" slot-scope="record">
                    <div class="user">
                        <div class="user-left">
                            <img class="cover-img" :src="record.avatarUrl || ''" width="48" height="48" alt="" />
                        </div>
                        <div class="user-right">
                            <p class="first">
                                <span class="nickname">{{ record.nickname }}</span>
                            </p>
                            <p class="row">
                                <span class="user-right-detail" v-if="record.sex === 'MALE'">男</span>
                                <span class="user-right-detail" v-else-if="record.sex === 'FEMALE'">女</span>
                                <span class="user-right-detail" v-if="record.age != null && record.age !== ''">{{ record.age }}岁</span>
                                <span class="user-right-detail">{{ record.province }}{{ record.city }}</span>
                            </p>
                        </div>
                    </div>
                </template>

                <span slot="bizType" slot-scope="record">
                    <label v-if="record.bizType == 'USER_PROFILE'">用户资料</label>
                    <label v-else-if="record.bizType == 'VOICE_MOTTO'">声音秀</label>
                    <label v-else-if="record.bizType == 'ALBUM'">相册照片</label>
                    <label v-else-if="record.bizType == 'MOMENT'">动态</label>
                    <label v-else-if="record.bizType == 'MOMENT_COMMENT'">评论</label>
                    <label v-else>-</label>
                </span>

                <template slot="snapshot" slot-scope="record">
                    <template v-if="record.bizType == 'USER_PROFILE'">
                        <div class="user-profile">
                            <div class="profile-avatar">
                                <x-image :src="record.snapshot.avatarUrl" :width="64" :height="64" />
                            </div>
                            <div class="profile-info">
                                <span class="nickname">{{ record.snapshot.nickname }}</span>
                                <p>{{ record.snapshot.motto }}</p>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="record.bizType == 'ALBUM'">
                        <x-image :src="record.snapshot.photoUrl" :width="64" :height="64" />
                    </template>
                    <template v-else-if="record.bizType == 'VOICE_MOTTO'">
                        <x-audio-player :src="record.snapshot.url" />
                    </template>
                    <template v-else-if="record.bizType == 'MOMENT'">
                        <p>{{ record.snapshot.content }}</p>
                        <div class="photo-list" v-if="record.snapshot.type == 'PHOTO'">
                            <div class="photo-item" v-for="(photoUrl, index) in record.snapshot.materials" :key="index">
                                <x-image :src="photoUrl" :width="64" :height="64" />
                            </div>
                        </div>
                        <div v-else>
                            <video-modal-player :videoSrc="record.snapshot.materials.videoUrl"
                                :thumbnail="record.snapshot.materials.coverUrl"
                            />
                        </div>
                    </template>
                    <template v-else-if="record.bizType == 'MOMENT_COMMENT'">
                        <div>{{ record.snapshot.content }}</div>
                    </template>
                    <div v-else>
                        {{ record.snapshot }}
                    </div>
                </template>

                <template slot="status" slot-scope="record">
                    <span v-if="record.status == 'PENDING'" class="wait">待审核</span>
                    <span v-else-if="record.status == 'PASSED'" class="success">通过</span>
                    <span v-else class="error">拒绝</span>
                    <p class="reason" v-if="record.auditRemark != ''">原因：{{ record.auditRemark }}</p>
                </template>

                <template slot="auditor" slot-scope="record">
                    <div v-if="record.auditTime > 0" class="audit-extra">
                        <span v-if="record.auditorUsername != ''">{{ record.auditorUsername }}</span>
                        <p>{{ record.auditTimeText }}</p>
                    </div>
                </template>

                <template slot="action" slot-scope="record">
					<template v-if="record.status == 'PENDING'">
						<a @click="auditPassed(record.id)">通过</a>
						<a-divider type="vertical" />
						<a @click="auditRejected(record.id)">拒绝</a>
					</template>
					<template v-else>
                        <span>-</span>
					</template>
				</template>
            </a-table>

            <div class="x-pagination">
                <a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
                              :hideOnSinglePage="true" show-less-items />
            </div>

            <refuse-form-modal ref="refuseFormModal" :visible="refuseFormVisible"
                :loading="refuseFormLoading" @cancel="refuseFormCancel" @ok="refuseFormOk" />
        </a-card>
    </div>
</template>

<script>
import moment from "moment/moment";
import XImage from "@/components/XImage";
import VideoModalPlayer from "@/components/VideoModalPlayer";
import XAudioPlayer from "@/components/XAudioPlayer";
import RefuseFormModal from "@/pages/op/moderate/RefuseFormModal";
import {moderateList, moderatePassed, moderateRefuse} from "@/api/op/moderate";

const tableColumns = [{
        title: '#',
        dataIndex: 'id'
    },
    {
        title: '用户',
        scopedSlots: {
            customRender: 'user'
        }
    },
    {
        title: '类型',
        scopedSlots: {
            customRender: 'bizType'
        }
    },
    {
        title: '审核快照',
        scopedSlots: {
            customRender: 'snapshot'
        },
        width: 500
    },
    {
        title: '审核状态',
        scopedSlots: {
            customRender: 'status'
        },
        width: 180
    },
    {
        title: '责任人',
        scopedSlots: {
            customRender: 'auditor'
        }
    },
    {
        title: '时间',
        dataIndex: 'created'
    },
    {
        title: '操作',
        scopedSlots: {
            customRender: 'action'
        }
    }
];

export default {
    components: {
        XImage,
        VideoModalPlayer,
        XAudioPlayer,
        RefuseFormModal
    },
    data() {
        return {
            advanced: false,
            queryParams: {},
            tableLoading: false,
            tableColumns,
            selectedRowKeys: [],
            tableData: [],
            totalRow: 0,
            pageSize: 20,
            pageIndex: 1,
            refuseFormVisible: false,
            refuseFormLoading: false,
        }
    },
    created() {
        this.getTableData();
    },
    methods: {
        getTableData() {
            this.tableLoading = true;
            this.queryParams.pageSize = this.pageSize;
            this.queryParams.page = this.pageIndex;

            moderateList(this.queryParams).then(res => {
                this.totalRow = res.data.totalRow;
                this.tableData = res.data.recordList;

                this.tableLoading = false;
            });
        },
        toggleAdvanced() {
            this.advanced = !this.advanced;
        },
        onCreateTime(values) {
            this.queryParams.startCreateTime = moment(values[0]).unix();
            this.queryParams.endCreateTime = moment(values[1]).unix();
        },
        pageChange(current) {
            this.pageIndex = current;
            this.getTableData();
        },
        auditPassed(id) {
            let ids = [id];
            moderatePassed(ids).then(() => {
                this.$message.success("操作成功");
                this.getTableData();
            });
        },
        auditRejected(id) {
            let ids = [id];
            this.$refs.refuseFormModal.form.ids = ids;
            this.refuseFormVisible = true;
        },
        refuseFormOk() {
            this.$refs.refuseFormModal.$refs['refuseForm'].validate(valid => {
                if(valid) {
                    this.refuseFormLoading = true;
                    const formData = this.$refs.refuseFormModal.form;
                    moderateRefuse(formData).then(() => {
                        this.refuseFormVisible = false;
                        this.refuseFormLoading = false;
                        this.getTableData();
                        this.$message.success("操作成功");
                    });
                } else {
                    return false;
                }
            });
        },
        refuseFormCancel() {
            this.refuseFormVisible = false;
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        batchAudit(e) {
            if(this.selectedRowKeys.length < 1) {
                this.$message.error("请选择要操作的记录");
                return false;
            }

            if(e.key == 'Y') { // 通过
                console.log("通过===");
                moderatePassed(this.selectedRowKeys).then(() => {
                    this.$message.success("操作成功");
                    this.getTableData();
                });
            } else {    // 拒绝
                console.log("拒绝===");
                this.$refs.refuseFormModal.form.ids = this.selectedRowKeys;
                this.refuseFormVisible = true;
            }
        }
    }
}
</script>

<style scoped lang="less">
.user {
    display: flex;
    flex-direction: row;

    .user-left {
        display: flex;
        flex-direction: column;
        margin-right: 8px;
        text-align: center;

        .cover-img {
            border-radius: 4px;
            object-fit: cover;
        }
    }

    .user-right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        p.first {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            margin: 0;

            .nickname {
                color: #686868;
                font-weight: bold;
            }

            .user-id {
                font-size: 12px;
                color: #acacac;
            }
        }

        p.row {
            font-size: 12px;
            color: #acacac;
            margin: 0;
        }

        .user-right-detail {
            margin-right: 5px;
        }
    }
}

.user-profile {
    display: flex;
    flex-direction: row;

    .profile-info {
        margin-left: 10px;

        span.nickname {
            font-weight:bold;
        }

        p {
            color: #8c8c8c;
        }
    }
}

.photo-list {
    display: flex;
    flex-direction: row;

    .photo-item {
        margin-right: 5px;
    }
}

.audit-extra {
    margin-top: 5px;

    span {
        font-size: 12px;
    }

    p {
        font-size: 12px;
        color: #acacac;
    }
}

.reason {
    font-size: 12px;
    color: #8c8c8c;
}
</style>